// =============================================================================
//  SCREEN: PlayerScreen
// =============================================================================
//  Zweck: Hauptansicht für die Verwaltung von Spielern.
// =============================================================================
import React, { useState, useEffect } from 'react';
import apiClient from '../api';
import PlayerList from '../components/PlayerList';

const PlayerScreen = () => {
  const [players, setPlayers] = useState([]);
  const [clubs, setClubs] = useState([]); // <-- NEU: State für die Vereinsliste
  const [editingPlayer, setEditingPlayer] = useState(null);
  
  // Formular-State
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [selectedClub, setSelectedClub] = useState(''); // Speichert die ID des gewählten Vereins
  
  const [error, setError] = useState('');

  useEffect(() => {
    // Lädt sowohl Spieler als auch Vereine beim Start
    const fetchData = async () => {
      try {
        const [playersRes, clubsRes] = await Promise.all([
          apiClient.get('/api/players'),
          apiClient.get('/api/clubs'),
        ]);
        setPlayers(playersRes.data);
        setClubs(clubsRes.data);
        // Setze den Default-Wert für das Dropdown, falls Vereine existieren
        if (clubsRes.data.length > 0) {
          setSelectedClub(clubsRes.data[0]._id);
        }
      } catch (err) {
        setError('Fehler beim Laden der Daten.');
      }
    };
    fetchData();
  }, []);

  const fetchPlayers = async () => {
    const { data } = await apiClient.get('/api/players');
    setPlayers(data);
  };

  const resetForm = () => {
    setEditingPlayer(null);
    setFirstName('');
    setLastName('');
    setSelectedClub(clubs.length > 0 ? clubs[0]._id : '');
    setError('');
  };

  const handleEdit = (player) => {
    setEditingPlayer(player);
    setFirstName(player.firstName);
    setLastName(player.lastName);
    // GEÄNDERT: Prüfen, ob der Spieler einen Verein hat, bevor dessen ID gesetzt wird.
    setSelectedClub(player.club ? player.club._id : '');
  };

  const handleDelete = async (id) => {
    if (window.confirm('Diesen Spieler wirklich löschen?')) {
      try {
        await apiClient.delete(`/api/players/${id}`);
        fetchPlayers();
      } catch (err) {
        setError(err.response?.data?.message || 'Fehler beim Löschen.');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!firstName || !lastName || !selectedClub) {
      setError('Alle Felder sind Pflichtfelder.');
      return;
    }

    const playerData = { firstName, lastName, club: selectedClub };

    try {
      if (editingPlayer) {
        await apiClient.put(`/api/players/${editingPlayer._id}`, playerData);
      } else {
        await apiClient.post('/api/players', playerData);
      }
      resetForm();
      fetchPlayers();
    } catch (err) {
      setError(err.response?.data?.message || 'Ein Fehler ist aufgetreten.');
    }
  };

  return (
    <div className="screen-container">
      <h2>Spielerverwaltung</h2>
      
      <div className="form-container">
        <h3>{editingPlayer ? 'Spieler bearbeiten' : 'Neuen Spieler anlegen'}</h3>
        <form onSubmit={handleSubmit}>
          {error && <p className="error-message">{error}</p>}
          <div className="form-group">
            <label>Vorname*</label>
            <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Nachname*</label>
            <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
          </div>
          <div className="form-group">
            <label>Verein*</label>
            <select value={selectedClub} onChange={(e) => setSelectedClub(e.target.value)}>
              {clubs.length === 0 ? (
                <option>Bitte zuerst Vereine anlegen</option>
              ) : (
                clubs.map((club) => (
                  <option key={club._id} value={club._id}>
                    {club.name}
                  </option>
                ))
              )}
            </select>
          </div>
          <div className="form-buttons">
            <button type="submit">{editingPlayer ? 'Änderungen speichern' : 'Spieler speichern'}</button>
            {editingPlayer && (
              <button type="button" className="btn-cancel" onClick={resetForm}>
                Abbrechen
              </button>
            )}
          </div>
        </form>
      </div>
      
      <hr />
      
      <PlayerList players={players} onEdit={handleEdit} onDelete={handleDelete} />
    </div>
  );
};

export default PlayerScreen;